// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__gbKhN","title":"Privacy_title__qNK2W","heading":"Privacy_heading__HhlX1","paragraph":"Privacy_paragraph__VupmP","ul":"Privacy_ul__XmFyA"};